(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["smoko-product-v15"] && !Shopify.designMode) return;
  try {
    
(function () {
  function scrollToReviews(pdp, e) {
    var target = document.getElementById('judgeme_product_reviews') || pdp.querySelector('.smk-app-wrap');
    if (!target) return;
    if (e) e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function bindBadge(pdp) {
    var slot = pdp.querySelector('#smk-badge-slot');
    if (!slot) return false;

    var badge = slot.querySelector('.jdgm-preview-badge');

    // Agar slot khali reh gaya, app-block wala badge utha kar yahan le aao
    if (!badge || !badge.textContent.trim()) {
      var loose = pdp.querySelector('.smk-app-wrap .jdgm-preview-badge');
      if (loose && loose.textContent.trim()) {
        if (badge) badge.remove();
        slot.insertBefore(loose, slot.firstChild);
        loose.classList.add('smk-jdgm-badge');
        badge = loose;
      }
    }

    if (!badge || !badge.textContent.trim()) return false;

    badge.style.setProperty('display', 'inline-block', 'important');
    badge.style.cursor = 'pointer';
    if (!badge.__smkBound) {
      badge.__smkBound = true;
      badge.addEventListener('click', function (e) { scrollToReviews(pdp, e); });
    }
    return true;
  }

  function initBadge(pdp) {
    function poke() {
      if (window.jdgm && typeof window.jdgm.customizeBadges === 'function') {
        try { window.jdgm.customizeBadges(); } catch (err) {}
      }
    }
    poke();
    if (bindBadge(pdp)) return;

    var tries = 0;
    var timer = setInterval(function () {
      tries++;
      poke();
      if (bindBadge(pdp) || tries > 25) clearInterval(timer);
    }, 400);
  }

  function init(root) {
    var pdp = document.querySelector('.smk-pdp');
    if (!pdp || pdp.__pdpBound) return;
    pdp.__pdpBound = true;

    initBadge(pdp);

    // Buy box accordions.
    // data-open-desktop="true"  -> open on laptops, shut on phones
    // data-open-desktop="false" -> shut everywhere until tapped
    var isPhone = window.matchMedia('(max-width: 900px)').matches;
    pdp.querySelectorAll('.smk-acc').forEach(function (acc) {
      var head = acc.querySelector('.smk-acc-h');
      if (!head) return;
      var openOnDesktop = acc.getAttribute('data-open-desktop') === 'true';
      var shut = isPhone ? true : !openOnDesktop;
      acc.classList.toggle('smk-shut', shut);
      head.setAttribute('aria-expanded', String(!shut));
      head.addEventListener('click', function () {
        var nowShut = acc.classList.toggle('smk-shut');
        head.setAttribute('aria-expanded', String(!nowShut));
      });
    });

    // Standalone specs section (only renders if switched back on)
    var specToggle = pdp.querySelector('#smkSpecToggle');
    var specGrid = pdp.querySelector('#smkSpecGrid');
    if (specToggle && specGrid) {
      var startClosed = isPhone;
      specGrid.classList.toggle('smk-hidden', startClosed);
      specToggle.setAttribute('aria-expanded', String(!startClosed));
      specToggle.addEventListener('click', function () {
        var nowHidden = specGrid.classList.toggle('smk-hidden');
        specToggle.setAttribute('aria-expanded', String(!nowHidden));
      });
    }

    // Gallery
    var thumbs = pdp.querySelectorAll('.thumb');
    var main = pdp.querySelector('#mainimg');
    var counter = pdp.querySelector('#galnow');
    var cur = 0;
    function setImg(i) {
      if (!thumbs.length) return;
      cur = (i + thumbs.length) % thumbs.length;
      var full = thumbs[cur].getAttribute('data-full');
      if (main && full) main.src = full;
      thumbs.forEach(function (t, n) { t.classList.toggle('active', n === cur); });
      if (counter) counter.textContent = cur + 1;
      var active = thumbs[cur];
      var row = pdp.querySelector('.smk-thumbrow');
      if (active && row) {
        var aL = active.offsetLeft, aR = aL + active.offsetWidth;
        if (aL < row.scrollLeft) row.scrollTo({ left: aL - 8, behavior: 'smooth' });
        else if (aR > row.scrollLeft + row.clientWidth) {
          row.scrollTo({ left: aR - row.clientWidth + 8, behavior: 'smooth' });
        }
      }
    }
    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { setImg(n); }); });
    var prev = pdp.querySelector('.gal-prev'), next = pdp.querySelector('.gal-next');
    if (prev) prev.addEventListener('click', function () { setImg(cur - 1); });
    if (next) next.addEventListener('click', function () { setImg(cur + 1); });

    // Price + qty + bundles
    var priceCents = parseInt(pdp.getAttribute('data-price-cents') || '0', 10) || 0;
    var compareAtCents = parseInt(pdp.getAttribute('data-compare-at-cents') || '0', 10) || 0;
    var currencySymbol = pdp.getAttribute('data-currency-symbol') || '$';
    var qtyInput = pdp.querySelector('#qty');
    var totalEl = pdp.querySelector('#total');
    var stickyPriceEl = pdp.querySelector('.fl-n');
    var syncTrayTotal = null;
    function money(n) {
      if (n % 1 === 0) return currencySymbol + n.toLocaleString();
      return currencySymbol + n.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
    function moneyCents(cents) {
      return money(cents / 100);
    }
    function parseMoneyCents(text) {
      var raw = String(text || '').replace(/[^0-9.,-]/g, '');
      if (!raw) return 0;
      var dot = raw.lastIndexOf('.');
      var comma = raw.lastIndexOf(',');
      if (dot > -1 && comma > -1) {
        if (dot > comma) raw = raw.replace(/,/g, '');
        else raw = raw.replace(/\./g, '').replace(',', '.');
      } else if (comma > -1) {
        raw = /,\d{2}$/.test(raw) ? raw.replace(',', '.') : raw.replace(/,/g, '');
      }
      var amount = parseFloat(raw);
      return isNaN(amount) ? 0 : Math.round(amount * 100);
    }
    function setTotalText(txt) {
      if (totalEl) totalEl.textContent = txt;
      if (stickyPriceEl) stickyPriceEl.textContent = txt;
    }
    function refreshBundles() {
      pdp.querySelectorAll('.bundle').forEach(function (bd) {
        var q = parseInt(bd.getAttribute('data-qty'), 10) || 1;
        var regularCents = priceCents * q;
        var savingCents = parseInt(bd.getAttribute('data-bundle-discount-cents') || '0', 10) || 0;
        if (savingCents < 0 || savingCents >= regularCents) savingCents = 0;
        var totalCents = regularCents - savingCents;
        bd.setAttribute('data-total-cents', String(totalCents));
        bd.setAttribute('data-saving-cents', String(savingCents));
        var now = bd.querySelector('.bundle-now');
        var each = bd.querySelector('.bundle-each');
        if (now) now.textContent = moneyCents(totalCents);
        if (each) each.textContent = savingCents > 0 ? 'Save ' + moneyCents(savingCents) : moneyCents(priceCents) + ' each';
      });
    }
    function selectedBaseCents() {
      var selected = pdp.querySelector('.bundle.sel');
      var q = parseInt(qtyInput ? qtyInput.value : '1', 10) || 1;
      if (selected) {
        var total = parseInt(selected.getAttribute('data-total-cents') || '0', 10);
        if (total > 0) return total;
      }
      return priceCents * q;
    }
    function refreshDynamicPriceDisplays() {
      pdp.setAttribute('data-price', String(priceCents / 100));
      pdp.setAttribute('data-price-cents', String(priceCents));
      pdp.setAttribute('data-compare-at-cents', String(compareAtCents));

      pdp.querySelectorAll('.smk-live-product-price').forEach(function (el) {
        el.textContent = moneyCents(priceCents);
      });
      pdp.querySelectorAll('.smk-live-product-price-once').forEach(function (el) {
        el.textContent = moneyCents(priceCents) + ' once';
      });

      var savingCents = compareAtCents > priceCents ? compareAtCents - priceCents : 0;
      var savingPct = compareAtCents > 0 ? Math.round(savingCents * 100 / compareAtCents) : 0;
      var savingAmountEl = pdp.querySelector('.smk-price-saving-amount');
      var savingPercentEl = pdp.querySelector('.smk-price-saving-percent');
      var savingWrap = pdp.querySelector('.bp-save');
      var mainWas = pdp.querySelector('.bp-was');
      var stickyWas = pdp.querySelector('.fl-was');
      if (savingAmountEl) savingAmountEl.textContent = moneyCents(savingCents);
      if (savingPercentEl) savingPercentEl.textContent = savingPct + '%';
      if (savingWrap) savingWrap.hidden = savingCents <= 0;
      if (mainWas) {
        mainWas.textContent = moneyCents(compareAtCents);
        mainWas.hidden = savingCents <= 0;
      }
      if (stickyWas) {
        stickyWas.textContent = moneyCents(compareAtCents);
        stickyWas.hidden = savingCents <= 0;
      }

      refreshBundles();
      if (typeof syncTrayTotal === 'function') syncTrayTotal();
      else setTotalText(moneyCents(selectedBaseCents()));
    }
    function recalcUnit() {
      setTotalText(moneyCents(selectedBaseCents()));
    }
    refreshDynamicPriceDisplays();
    pdp.querySelectorAll('.bundle').forEach(function (bd) {
      bd.addEventListener('click', function () {
        pdp.querySelectorAll('.bundle').forEach(function (x) { x.classList.remove('sel'); });
        bd.classList.add('sel');
        var q = parseInt(bd.getAttribute('data-qty'), 10) || 1;
        if (qtyInput) qtyInput.value = q;
        if (typeof syncTrayTotal === 'function') syncTrayTotal();
        else recalcUnit();
      });
    });
    var selBundle = pdp.querySelector('.bundle.sel');
    if (selBundle) {
      var q0 = parseInt(selBundle.getAttribute('data-qty'), 10) || 1;
      if (qtyInput) qtyInput.value = q0;
      recalcUnit();
    } else {
      recalcUnit();
    }

    var priceArea = pdp.querySelector('.buy-price');
    if (priceArea && typeof MutationObserver !== 'undefined') {
      var priceObserver = new MutationObserver(function () {
        var currentPrice = pdp.querySelector('.bp-now');
        var currentCompare = pdp.querySelector('.bp-was');
        var nextPriceCents = parseMoneyCents(currentPrice ? currentPrice.textContent : '');
        var nextCompareAtCents = parseMoneyCents(currentCompare ? currentCompare.textContent : '');
        if (nextPriceCents <= 0) return;
        if (nextCompareAtCents <= 0) nextCompareAtCents = compareAtCents;
        if (nextPriceCents === priceCents && nextCompareAtCents === compareAtCents) return;
        priceCents = nextPriceCents;
        compareAtCents = nextCompareAtCents;
        refreshDynamicPriceDisplays();
      });
      priceObserver.observe(priceArea, { childList: true, characterData: true, subtree: true });
    }

    // ===== SPARE TRAY ADD-ON =====
    var trayBox = pdp.querySelector('#smkTray');
    if (trayBox) {
      var singleId = pdp.querySelector('#smkSingleId');
      var i0id = pdp.querySelector('#smkItem0Id'), i0q = pdp.querySelector('#smkItem0Qty');
      var i1id = pdp.querySelector('#smkItem1Id'), i1q = pdp.querySelector('#smkItem1Qty');
      var traySummaryAction = trayBox.querySelector('.smk-tray-toggle-action');

      // true only when the real tray variant rendered its cart inputs
      var purchasable = !!(i0id && i0q && i1id && i1q);
      var trayQty = 0;
      var trayTotalCents = 0;

      // whatever the lunchbox bundle/qty logic has already worked out, as a number
      function baseTotalCents() {
        return selectedBaseCents();
      }

      function syncTray() {
        var boxQty = parseInt(qtyInput ? qtyInput.value : '1', 10) || 1;

        if (purchasable) {
          var on = trayQty > 0;
          // no tray  -> post id + quantity, exactly as before
          // with tray -> post items[] so both lines land in one cart action
          if (singleId) singleId.disabled = on;
          if (qtyInput) qtyInput.name = on ? '' : 'quantity';
          [i0id, i0q, i1id, i1q].forEach(function (el) { el.disabled = !on; });
          i0q.value = boxQty;
          i1q.value = trayQty > 0 ? trayQty : 1;
        } else {
          // preview mode. Leave the real form alone so the lunchbox still adds
          // correctly, and never submit a tray variant that does not exist.
          if (singleId) singleId.disabled = false;
          if (qtyInput) qtyInput.name = 'quantity';
        }

        var totalCents = baseTotalCents() + trayTotalCents;
        setTotalText(moneyCents(totalCents));
        if (traySummaryAction) {
          traySummaryAction.textContent = trayQty > 0
            ? trayQty + (trayQty === 1 ? ' tray added' : ' trays added')
            : 'View options';
        }

      }
      syncTrayTotal = syncTray;

      var trayOpts = trayBox.querySelectorAll('.smk-tray-opt');
      trayOpts.forEach(function (opt) {
        opt.addEventListener('click', function () {
          trayOpts.forEach(function (o) {
            o.classList.remove('sel');
            o.setAttribute('aria-pressed', 'false');
          });
          opt.classList.add('sel');
          opt.setAttribute('aria-pressed', 'true');
          trayQty = parseInt(opt.getAttribute('data-tray'), 10) || 0;
          trayTotalCents = parseInt(opt.getAttribute('data-addon-cents') || '0', 10) || 0;
          syncTray();
        });
      });

      // run after the bundle handler so the total stays right
      pdp.querySelectorAll('.bundle').forEach(function (el) {
        el.addEventListener('click', function () { setTimeout(syncTray, 0); });
      });

      syncTray();
    }
  }
  if (document.readyState !== 'loading') init(document);
  else document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) {
    var p = document.querySelector('.smk-pdp'); if (p) p.__pdpBound = false; init(e.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["smoko-producttray"] && !Shopify.designMode) return;
  try {
    
(function () {
  window.smkTrayFaq = function (button) {
    var item = button.closest('.fq');
    if (!item) return;
    item.classList.toggle('open');
  };

  function scrollToReviews(pdp, e) {
    var target = document.getElementById('judgeme_product_reviews') || pdp.querySelector('.smk-app-wrap');
    if (!target) return;
    if (e) e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function bindBadge(pdp) {
    var slot = pdp.querySelector('#smk-badge-slot');
    if (!slot) return false;

    var badge = slot.querySelector('.jdgm-preview-badge');

    // Agar slot khali reh gaya, app-block wala badge utha kar yahan le aao
    if (!badge || !badge.textContent.trim()) {
      var loose = pdp.querySelector('.smk-app-wrap .jdgm-preview-badge');
      if (loose && loose.textContent.trim()) {
        if (badge) badge.remove();
        slot.insertBefore(loose, slot.firstChild);
        loose.classList.add('smk-jdgm-badge');
        badge = loose;
      }
    }

    if (!badge || !badge.textContent.trim()) return false;

    badge.style.setProperty('display', 'inline-block', 'important');
    badge.style.cursor = 'pointer';
    if (!badge.__smkBound) {
      badge.__smkBound = true;
      badge.addEventListener('click', function (e) { scrollToReviews(pdp, e); });
    }
    return true;
  }

  function initBadge(pdp) {
    function poke() {
      if (window.jdgm && typeof window.jdgm.customizeBadges === 'function') {
        try { window.jdgm.customizeBadges(); } catch (err) {}
      }
    }
    poke();
    if (bindBadge(pdp)) return;

    var tries = 0;
    var timer = setInterval(function () {
      tries++;
      poke();
      if (bindBadge(pdp) || tries > 25) clearInterval(timer);
    }, 400);
  }

  function init(root) {
    var pdp = document.querySelector('.smk-tray-pdp');
    if (!pdp || pdp.__pdpBound) return;
    pdp.__pdpBound = true;

    initBadge(pdp);

    // Buy box accordions.
    // data-open-desktop="true"  -> open on laptops, shut on phones
    // data-open-desktop="false" -> shut everywhere until tapped
    var isPhone = window.matchMedia('(max-width: 900px)').matches;
    pdp.querySelectorAll('.smk-acc').forEach(function (acc) {
      var head = acc.querySelector('.smk-acc-h');
      if (!head) return;
      var openOnDesktop = acc.getAttribute('data-open-desktop') === 'true';
      var shut = isPhone ? true : !openOnDesktop;
      acc.classList.toggle('smk-shut', shut);
      head.setAttribute('aria-expanded', String(!shut));
      head.addEventListener('click', function () {
        var nowShut = acc.classList.toggle('smk-shut');
        head.setAttribute('aria-expanded', String(!nowShut));
      });
    });

    // Standalone specs section (only renders if switched back on)
    var specToggle = pdp.querySelector('#smkSpecToggle');
    var specGrid = pdp.querySelector('#smkSpecGrid');
    if (specToggle && specGrid) {
      var startClosed = isPhone;
      specGrid.classList.toggle('smk-hidden', startClosed);
      specToggle.setAttribute('aria-expanded', String(!startClosed));
      specToggle.addEventListener('click', function () {
        var nowHidden = specGrid.classList.toggle('smk-hidden');
        specToggle.setAttribute('aria-expanded', String(!nowHidden));
      });
    }

    // Gallery
    var thumbs = pdp.querySelectorAll('.thumb');
    var main = pdp.querySelector('#mainimg');
    var counter = pdp.querySelector('#galnow');
    var cur = 0;
    function setImg(i) {
      if (!thumbs.length) return;
      cur = (i + thumbs.length) % thumbs.length;
      var full = thumbs[cur].getAttribute('data-full');
      if (main && full) main.src = full;
      thumbs.forEach(function (t, n) { t.classList.toggle('active', n === cur); });
      if (counter) counter.textContent = cur + 1;
      var active = thumbs[cur];
      var row = pdp.querySelector('.smk-thumbrow');
      if (active && row) {
        var aL = active.offsetLeft, aR = aL + active.offsetWidth;
        if (aL < row.scrollLeft) row.scrollTo({ left: aL - 8, behavior: 'smooth' });
        else if (aR > row.scrollLeft + row.clientWidth) {
          row.scrollTo({ left: aR - row.clientWidth + 8, behavior: 'smooth' });
        }
      }
    }
    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { setImg(n); }); });
    var prev = pdp.querySelector('.gal-prev'), next = pdp.querySelector('.gal-next');
    if (prev) prev.addEventListener('click', function () { setImg(cur - 1); });
    if (next) next.addEventListener('click', function () { setImg(cur + 1); });

    // Price + qty + bundles
    var price = parseFloat(pdp.getAttribute('data-price') || '0');
    var qtyInput = pdp.querySelector('#qty');
    var totalEl = pdp.querySelector('#total');
    var stickyPriceEl = pdp.querySelector('.fl-n');
    function money(n) {
      if (n % 1 === 0) return '$' + n.toLocaleString();
      return '$' + n.toFixed(2);
    }
    function setTotalText(txt) {
      if (totalEl) totalEl.textContent = txt;
      if (stickyPriceEl) stickyPriceEl.textContent = txt;
    }
    function recalcUnit() {
      var q = parseInt(qtyInput ? qtyInput.value : '1', 10) || 1;
      setTotalText(money(price * q));
    }
    function selectBundle(bd) {
        pdp.querySelectorAll('.bundle').forEach(function (x) { x.classList.remove('sel'); });
        pdp.querySelectorAll('.bundle').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        bd.classList.add('sel');
        bd.setAttribute('aria-pressed', 'true');
        var q = parseInt(bd.getAttribute('data-qty'), 10) || 1;
        if (qtyInput) qtyInput.value = q;
        var totalCents = parseInt(bd.getAttribute('data-total-cents'), 10);
        if (!isNaN(totalCents)) setTotalText(money(totalCents / 100));
        else setTotalText(money(price * q));
    }
    pdp.querySelectorAll('.bundle').forEach(function (bd) {
      bd.addEventListener('click', function () { selectBundle(bd); });
      bd.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          selectBundle(bd);
        }
      });
    });
    var selBundle = pdp.querySelector('.bundle.sel');
    if (selBundle) {
      var q0 = parseInt(selBundle.getAttribute('data-qty'), 10) || 1;
      if (qtyInput) qtyInput.value = q0;
      var totalCents0 = parseInt(selBundle.getAttribute('data-total-cents'), 10);
      setTotalText(!isNaN(totalCents0) ? money(totalCents0 / 100) : money(price * q0));
    } else {
      recalcUnit();
    }
  }
  if (document.readyState !== 'loading') init(document);
  else document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) {
    var p = document.querySelector('.smk-tray-pdp'); if (p) p.__pdpBound = false; init(e.target);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
